export const MinusIcon = () => {
    return (
        <svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg" className="fill-black dark:fill-white">
            <path d="M0 0H8V2H0V0Z" />
        </svg>
    );
};
